import React from 'react';
import { Drawer } from 'antd';
import EntryForm from "./EntryForm";

const EntryDrawer = ({ visible, onClose, initialUUID, onEntryCreated }) => {
    return (
        <Drawer
            title="Create a new Entry"
            width={720}
            onClose={onClose}
            visible={visible}
            bodyStyle={{ paddingBottom: 80 }}
        >
            <EntryForm initialUUID={initialUUID} onEntryCreated={onEntryCreated} />
        </Drawer>
    );
};

export default EntryDrawer;
